<template>
  <div class="fts-template-editor formula-expression">
    <div class="editor-content" v-if="disabled">
      <div class="template-editor" v-html="content" />
    </div>

    <vue-tribute
      :options="tributeOptions"
      class="editor-content"
      v-else
    >
      <div
        ref="formulaExpression"
        @click="openExpressionEditor"
        @input="updateContent($event.target)"
        v-html="content"
        class="template-editor"
        placeholder="type # for hints"
        contenteditable="true"
        @paste.prevent="paste($event)"
      />
    </vue-tribute>

    <div class="editor-expression">{{innerExpression}}</div>
    <!-- expression editor modal -->
    <fts-design-modal title="Expression Editor" ref="expressionEditorModal">
      <!-- body -->
      <template #body>
        <div>
          <div class="fts-form-group">
            <fts-expression :information="information" v-model="expressionEditorFormData.formula" />
          </div>
          
          <div class="fts-form-group">
            <fts-form-label placement="top">Format</fts-form-label>
            <fts-select 
              :form-data="expressionEditorFormData"
              :item="{fieldName: 'format'}"
              :options="dateFormats" 
              reduce-key="cSharp"
            />
          </div>
        </div>
      </template>
      <!-- footer -->
      <template #footer>
        <fts-btn outline color="primary" @click="submit">Done</fts-btn>
      </template>
    </fts-design-modal>
  </div>
</template>
<script>
import VueTribute from "vue-tribute";
import "tributejs/dist/tribute.css";

import commons from "../commons/commons";
import tributeCaretMixin from "../commons/tributeCaretMixin";

import FTSDesignModal from "./FTSDesignModal";
import FTSFormulaInformationUnit from "./formula/FTSFormulaInformationUnit";
import FTSExpression from "./FTSExpression";
import FTSBtn from "../elements/FTSBtn";
import FTSSelect from "../elements/FTSSelect";
import FTSFormLabel from "../elements/FTSFormLabel";

export default {
  mixins: [tributeCaretMixin],
  components: {
    VueTribute,
    "fts-design-modal": FTSDesignModal,
    "fts-formula-information-unit": FTSFormulaInformationUnit,
    "fts-expression": FTSExpression,
    "fts-btn": FTSBtn,
    "fts-select": FTSSelect,
    "fts-form-label": FTSFormLabel,
  },
  props: {
    template: String,
    information: Array,
    type: String,
    disabled: Boolean,
  },
  model: {
    prop: "template",
  },
  data: () => ({
    content: "",
    innerExpression: "",
    currentFormulaTarget: null,
    tributeOptions: {
      trigger: "#",
      allowSpaces: true,
      values: [],
      lookup: "displayName",
      requireLeadingSpace: false,
      replaceTextSuffix: "",
      itemClass: "information-unit-select",
      menuItemTemplate: function (item) {
        return `<span><i class="information-icon ${commons.informationIcon(
          item.original.type
        )}"></i> <span>${item.string}</span></span>`; //item.string
      },
    },
    // expression editor
    dateFormats: commons.dateFormats,
    expressionEditorFormData: {}
  }),
  methods: {
    submit() {
      this.$refs.expressionEditorModal.close();
      let re2 = /field\('(?<display>.*?)'\)/g;
      this.expressionEditorFormData.formula = this.expressionEditorFormData.formula.replace(
        re2, "<fts-i-unit>$1</fts-i-unit>"
      );

      this.currentFormulaTarget.innerHTML = this.expressionEditorFormData.formula;

      if (this.expressionEditorFormData.format != null && this.expressionEditorFormData.format.length > 0) {
        this.currentFormulaTarget.innerHTML += "|" + this.expressionEditorFormData.format
      }
      this.updateContent(this.$refs.formulaExpression);
    },
    openExpressionEditor($event) {
      this.expressionEditorFormData = {}

      let target = $event.target;
      if ($event.target.nodeName == "FTS-I-UNIT") {
        target = target.parentNode;
      }

      if (target.nodeName == "FTS-I-EXPRESSION") {
        this.$refs.expressionEditorModal.show();
        this.currentFormulaTarget = target;
        var components = target.innerHTML.split("|");
        let re2 = /<fts-i-unit>(?<display>.*?)<\/fts-i-unit>/g;
        this.$set(this.expressionEditorFormData, 'formula', components[0].replace(re2, "field('$1')"))
        if (components.length > 1) 
          this.$set(this.expressionEditorFormData, 'format', components[1])
      }
    },
    paste(evt) {
      var text = evt.clipboardData.getData("text/plain");
      document.execCommand("insertHTML", false, text);
    },
    updateContent(target) {
      console.log(target.innerText);
      let re = /<fts-i-expression contenteditable="false">(?<expression>.*?)<\/fts-i-expression>/g;
      let formulaText = target.innerHTML.replace(re, "{$1}");

      let re2 = /<fts-i-unit>(?<display>.*?)<\/fts-i-unit>/g;
      formulaText = formulaText.replace(re2, "field('$1')");
      // formulaText = formulaText.replaceAll("&nbsp;", " ");
      // formulaText = formulaText.replaceAll("<br>", "");

      if (this.type == "text") {
        formulaText = formulaText.replace(
          /<div>(?<line>.*?)<\/div>/sg,
          "\n\r$1"
        );
        formulaText = formulaText.replaceAll("<br>", "\n\r");
      }

      this.innerExpression = formulaText;
      this.$emit("input", formulaText);
    },
    async autofill(text, cb) {
      cb(this.selection);
    },
    selectTemplate(item) {
      return `<fts-i-expression contenteditable="false"><fts-i-unit>${item.original.displayName}</fts-i-unit></fts-i-expression>`;
    },
    updateDisplay(formula) {
      let re = /\{(?<expression>.*?)\}/g;
      let re2 = /field\('(?<display>.*?)'\)/g;
      try {
        this.content = formula
          .replace(
            re,
            '<fts-i-expression contenteditable="false">$1</fts-i-expression>'
          )
          .replace(re2, "<fts-i-unit>$1</fts-i-unit>")
          .replace()
          .replace("<br>", "");
      } catch (err) {
        console.warn(`FTSExpression error: ${err}`);
      }

      this.innerExpression = formula;
    },
  },
  computed: {
    selection() {
      return this.information.concat([
        { displayName: "#DocumentID" },
        { displayName: "#Date" },
        { displayName: "#Created By" },
        { displayName: "#Created Date" },
        { displayName: "#Updated By" },
        { displayName: "#Updated Date" },
        { displayName: "#State" },
      ]);
    },
  },
  watch: {
    formula(newVal) {
      if (!newVal) {
        this.content = "";
        this.innerExpression = "";
        this.$refs.formulaExpression.innerHTML = "";
      }
    },
  },
  mounted() {
    let vm = this;
    this.tributeOptions.selectTemplate = this.selectTemplate;
    this.tributeOptions.values = function (text, cb) {
      vm.autofill(text, (users) => cb(users));
    };
    this.bindTributeCaretGuard();
    this.updateDisplay(this.template);
  },
};
</script>

<style lang="scss">
@use "./src/assets/scss/colors" as *;

$editorColor: #efefef;

.fts-template-editor {
  .editor-content {
    padding: .375rem;
    border: 1px solid $editorColor;
    font-size: .875rem;
  }
  .editor-expression {
    padding: .375rem;
    font-size: .675rem;
    color: $grayColor;
    background: $editorColor;
  }
}

.template-editor fts-i-expression {
  background-color: rgb(247, 255, 200);
  padding: 3px;
  margin: 2px;
}

.template-editor fts-i-unit {
  background-color: rgb(200, 240, 255);
  padding: 1px;
  margin: 2px;
}

.information-unit-select {
  margin: 3px;
}

.template-editor {
  line-height: 1.5;
  white-space: pre-wrap;

  &:empty:before {
    content: attr(placeholder);
    -webkit-text-fill-color: $grayLightColor;
  }
}
</style>